import React, { Component } from 'react';
import { Modal, Button, Input, message, InputNumber, Select } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import RemittanceModal from './RemittanceModal';
import './index.less';

const Option = Select.Option;

class SingleMark extends Component {
    state = {
        data: [],
        params: {},
        visible: false,
        remittanceCodeList: [],
        remittanceCodeDatas: [],
        contractRate: 0,
    }

    show = (record = {}) => {
        const { 
            jdeCode, 
            lastExpenses, 
            actualExpenses, 
            contractRate,
            ptPriceStatus,
            remittanceApplicationIds: ids, 
            remittanceCodes: names,
        } = record;
        console.log(lastExpenses);
        let lastExpensesValue = 0;
        if (this.booleanEquals(ptPriceStatus,['Pending','Approval_Progress','Unregistered_Payment'])) {
            lastExpensesValue = undefined;
        } else {
            lastExpensesValue = (lastExpenses || lastExpenses == 0) ? lastExpenses : actualExpenses;
        }
        
        this.setState({
            params: { 
                ...record,
                remittanceApplicationIds: ids ? ids.split(',') : [],
                remittanceCodes: names ? names.split(',') : [],
                lastExpenses: lastExpensesValue,
            },
            visible: true,
            contractRate,
        },() => {
            this.queryRemittanceCodedData(jdeCode);
        });
    }

    hide = () => {
        this.setState({
            data: [],
            params: {},
            visible: false,
        });
    }

    handleChange = (value, key) => {
        const { params, remittanceCodeList, contractRate } = this.state;
        const { approvedAmount, actualExpensesRate, ptPriceStatus } = params;

        switch (key) {
            case 'actualExpensesRate':
                console.log(!value);
                //判断字符串是否包含字母
                if (/[A-Za-z]/.test(value)) {
                    params[key] = undefined;
                } else {
                    params[key] = value.indexOf('.') == -1 ? value : value.replace(/(\.\d{2})\d+/, '$1'); //保留字符串小数点后两位
                    if (value) {
                        params.actualExpensesTax = Number((approvedAmount * Number(value) * 0.01).toFixed(2));
                        params.actualExpenses = Number((params.actualExpensesTax + approvedAmount).toFixed(2));
                    } else {
                        params.actualExpensesTax = undefined;
                        params.actualExpenses = Number(approvedAmount.toFixed(2));
                    }
                    if (this.booleanEquals(ptPriceStatus,['Pending','Approval_Progress','Unregistered_Payment'])) {
                        params.lastExpenses = undefined;
                    } else {
                        params.lastExpenses = Number(params.actualExpenses.toFixed(2));
                    }
                }
                break;
            case 'remittanceApplicationIds':
                const codeNames = [];
                const paymentProgressCodes = [];
                params[key] = value;
                if (value && value.length) {
                    remittanceCodeList.map(datas => {
                        value.map(id => {
                            if (datas.contractRemittanceApplicationId == id) {
                                codeNames.push(datas.remittanceCode);
                                paymentProgressCodes.push(datas.paymentProgressCode);
                            }
                        })
                    })
                }
                params.remittanceCodes = codeNames;
                params.paymentProgressCodes = Array.from(new Set(paymentProgressCodes));
                break;
            case 'ptPriceStatus':
                params[key] = value;
                params.statusRemark = undefined;
                if (value == 'OTHER') {
                    params.actualExpensesRate = undefined;
                    params.actualExpensesTax = undefined;
                    params.actualExpenses = Number(approvedAmount.toFixed(2));
                } else {
                    params.actualExpensesRate = actualExpensesRate ? actualExpensesRate : contractRate;
                    if (params.actualExpensesRate) {
                        params.actualExpensesTax = Number((approvedAmount * Number(params.actualExpensesRate) * 0.01).toFixed(2));
                        params.actualExpenses = Number((params.actualExpensesTax + approvedAmount).toFixed(2));
                    } else {
                        params.actualExpensesTax = undefined;
                        params.actualExpenses = Number(approvedAmount.toFixed(2));
                    }
                }
                if (!this.booleanEquals(value, ['Registered_Issue_Invoice','Invoiced_Not_Paid','Invoiced_Paid','Not_Invoiced_Paid','Clinical_Resources_Absorption','Project_Undertaking','OTHER'])) {
                    params.remittanceApplicationIds = [];
                }
                if (this.booleanEquals(value,['Pending','Approval_Progress','Unregistered_Payment'])) {
                    params.lastExpenses = undefined;
                } else {
                    params.lastExpenses = Number(params.actualExpenses.toFixed(2));;
                }
                break;
            default:
                params[key] = value;
                break;
        }
        this.setState({ params });
    }

    //判断字段是否等于某些值
    booleanEquals = (key, value = []) => {
        return value.some((el) => key === el);
    };

    submit = () => {
        const { params } = this.state;
        const { ptPriceStatus, statusRemark, actualExpensesRate, lastExpenses, whetherInvPm } = params;
        console.log(whetherInvPm, ptPriceStatus, actualExpensesRate);
        console.log(!actualExpensesRate);
        //校验必填
        const canEdit = this.booleanEquals(ptPriceStatus, ['Registered_Issue_Invoice','Invoiced_Not_Paid','Invoiced_Paid','Not_Invoiced_Paid','Clinical_Resources_Absorption','Project_Undertaking','OTHER']);

        if (!ptPriceStatus) {
            return message.warning(`标记状态不能为空`)
        }
        if (ptPriceStatus == 'OTHER' && !statusRemark) {
            return message.warning(`其他状态说明不能为空`)
        }
        if (whetherInvPm === 0 && ptPriceStatus != 'OTHER' && actualExpensesRate != 0 && !actualExpensesRate) {
            return message.warning(`申请结算税率不能为空`)
        }
        if (canEdit && lastExpenses != 0 && !lastExpenses) {
            return message.warning(`最终结算金额（含税）不能为空`)
        } 
        let sendData = {};
        const { remittanceApplicationIds, remittanceCodes, paymentProgressCodes } = params;
        params.remittanceApplicationIds = (remittanceApplicationIds || []).join(',');
        params.remittanceCodes = (remittanceCodes || []).join(',');
        params.paymentProgressCodes = (paymentProgressCodes || []).join(',');
        for (const key in params) {
            sendData[`ptPriceRecordList[0].${key}`] = params[key];
        }
        const options = {
            method: 'POST',
            url: API_URL.contract.markPtPriceStatus,
            data: {
                ...sendData,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.props.loadData();
            }
        };
        $.sendRequest(options);
    }

    queryRemittanceCodedData = jdeCode => {
        if (!jdeCode) return
        const options = {
            method: 'POST',
            url: API_URL.contract.queryContractRemittanceList,
            data: {
                investigationJdeCode: jdeCode,
                expenseTypeId: '4',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res.data;
                let remittanceCodeData = [];
                datas.map(el => {
                    remittanceCodeData.push({
                        contractRemittanceApplicationId: el.contractRemittanceApplicationId,
                        remittanceCode: el.remittanceCode,
                        paymentProgressCode: el.paymentProgressCode,
                    });
                });
                this.setState({
                    remittanceCodeList: remittanceCodeData,
                    remittanceCodeDatas: datas,
                })
            },
        };
        $.sendRequest(options);
    }

    render() {
        const { visible, params, remittanceCodeList, remittanceCodeDatas } = this.state;
        const { 
            reimbursementNum, 
            jdeCode, 
            customerCompanyNameCode, 
            approvedAmount, 
            actualExpenses, 
            actualExpensesRate, 
            actualExpensesTax, 
            lastExpenses,
            ptPriceStatus, 
            statusRemark, 
            remittanceCode, 
            remittanceApplicationIds,
            actualExpensesRateList,
            whetherInvPm,
        } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const { statusList = [] } = this.props;
        const remittanceCodeOption = (remittanceCodeList || []).map(el => <Option key={String(el.contractRemittanceApplicationId)} value={String(el.contractRemittanceApplicationId)}>{el.remittanceCode}</Option>);
        const statusOption = statusList.map(el => <Option key={el.value} value={el.value}>{el.label}</Option>)
        const actualExpensesRateOption = (actualExpensesRateList || []).map(el => <Option key={String(el)} value={String(el)}>{el}</Option>);
        return (
            <Modal
                title={`标记状态`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="preview-modal"
                maskClosable={false}
                width="550px"
            >
                <div className="modal-content" style={{ padding: '0 20px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{'报销单号:'}</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {reimbursementNum}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{'JDE项目号:'}</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {jdeCode}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{'客户名称:'}</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {customerCompanyNameCode}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{'Ariba&OA审批通过金额:'}</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {approvedAmount}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{asterisk}{'标记状态:'}</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                <Select
                                    placeholder='请选择'
                                    style={{ width: 140 }}
                                    value={ptPriceStatus}
                                    onChange={value => this.handleChange(value, 'ptPriceStatus')}
                                >
                                    {statusOption}
                                </Select>
                            </div>
                        </li>
                        {
                            ptPriceStatus == 'OTHER' &&
                                <li className="modal-item">
                                    <div className="item-left" style={{ width: '40%' }}>{asterisk}{'其他状态说明:'}</div>
                                    <div className="item-right" style={{ width: '60%' }}>
                                        <Input
                                            placeholder='请输入'
                                            style={{ width: 140 }}
                                            value={statusRemark}
                                            onChange={e => this.handleChange(e.target.value, 'statusRemark')}
                                        />
                                    </div>
                                </li>
                        }
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{'申请结算金额（含税）:'}</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {actualExpenses}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{'申请结算税率（%）:'}</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {
                                    (ptPriceStatus == 'OTHER')  ? '' : (whetherInvPm == 1 ? actualExpensesRate:<Select
                                        mode="combobox"
                                        filterOption={true}
                                        style={{ width: 140 }}
                                        // placeholder="请输入"
                                        value={actualExpensesRate}
                                        onChange={value => this.handleChange(value, 'actualExpensesRate')}
                                    >
                                        {actualExpensesRateOption}
                                    </Select>)
                                }
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{'申请结算税费:'}</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {actualExpensesTax}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{'最终结算金额（含税）:'}</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {
                                    this.booleanEquals(ptPriceStatus,['Pending','Approval_Progress','Unregistered_Payment']) ? '' : <InputNumber
                                            placeholder='请输入'
                                            precision={2}
                                            style={{ width: 140 }}
                                            value={lastExpenses}
                                            onChange={value => this.handleChange(value, 'lastExpenses')}
                                        /> 
                                }
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ width: '40%' }}>{'请款单号:'}</div>
                            <div className="item-right" style={{ width: '60%' }}>
                                {
                                    this.booleanEquals(ptPriceStatus, ['Registered_Issue_Invoice','Invoiced_Not_Paid','Invoiced_Paid','Not_Invoiced_Paid','Clinical_Resources_Absorption','Project_Undertaking','OTHER']) ? <div onClick={() => this.remittanceModalRef.show(remittanceApplicationIds, remittanceCodeDatas)}>
                                        <Select
                                            placeholder='请选择'
                                            dropdownClassName='hiddenSelectBox'
                                            style={{ width: 140 }}
                                            mode='multiple'
                                            value={remittanceApplicationIds}
                                            onChange={value => this.handleChange(value, 'remittanceApplicationIds')}
                                        >
                                            {remittanceCodeOption}
                                        </Select> 
                                    </div> : ''
                                }
                            </div>
                        </li>
                    </ul>
                </div>
                <RemittanceModal
                    ref={el => this.remittanceModalRef = el}
                    onChange={this.handleChange}
                />
            </Modal>
        );
    }
}

export default SingleMark;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ptReimburse/SingleMark.js